import React from "react";
import "./Button.scss";

const Button = (props) => {
  return (
    <div className="btn-main-container">
      <button type="button" class="btn" onClick={() => props?.onClick()}>
        {props?.name}
      </button>
    </div>
  );
};

export default Button;
